import { useState, useEffect, useCallback } from 'react';

const EASTER_EGG_SEQUENCE = 'trippy';
const STORAGE_KEY = 'yoda-trippy-mode';

export function useEasterEgg() {
  const [isActive, setIsActive] = useState(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });
  const [typedKeys, setTypedKeys] = useState('');

  const toggle = useCallback(() => {
    setIsActive((prev) => {
      const newValue = !prev;
      localStorage.setItem(STORAGE_KEY, String(newValue));
      return newValue;
    });
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignore if user is typing in an input/textarea
      const target = e.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return;
      }

      const key = e.key.toLowerCase();

      // Only track alphabetic keys
      if (key.length === 1 && /[a-z]/.test(key)) {
        setTypedKeys((prev) => {
          const newKeys = (prev + key).slice(-EASTER_EGG_SEQUENCE.length);

          if (newKeys === EASTER_EGG_SEQUENCE) {
            // Toggle trippy mode
            toggle();
            return '';
          }

          return newKeys;
        });
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggle]);

  // Clear typed keys after 2 seconds of inactivity
  useEffect(() => {
    if (typedKeys.length === 0) return;

    const timeout = setTimeout(() => {
      setTypedKeys('');
    }, 2000);

    return () => clearTimeout(timeout);
  }, [typedKeys]);

  return { isTrippyMode: isActive, toggleTrippyMode: toggle };
}
